export function createDom(tpl) {
  const container = document.createElement('div')
  container.innerHTML = tpl
  return container.firstElementChild
}
export function children(element) {
  const childrenNodes = Array.prototype.slice.call(element.childNodes)
  return childrenNodes.filter((node) => {
    return node.nodeType === 1
  })
}
export function removeDom(dom) {
  if (!dom || !dom.parentNode) {
    return
  }
  dom.parentNode.removeChild(dom)
}
export function hasClass(el, className) {
  const reg = new RegExp('(^|\\s)' + className + '(\\s|$)')
  return reg.test(el.className)
}

export function removeClass(el, className) {
  if (!hasClass(el, className)) {
    return
  }

  const reg = new RegExp('(^|\\s)' + className + '(\\s|$)', 'g')
  el.className = el.className.replace(reg, '') // eslint-disable-line no-param-reassign
}

export function addClass(el, className) {
  if (hasClass(el, className)) {
    return
  }

  const newClass = el.className.split(' ')
  newClass.push(className)
  el.className = newClass.join(' ') // eslint-disable-line no-param-reassign
}

export function eleMatch(target, targetSelector) {
  Element.prototype.matches = Element.prototype.matches ||
                              Element.prototype.matchesSelector ||
                              Element.prototype.mozMatchesSelector ||
                              Element.prototype.msMatchesSelector ||
                              Element.prototype.oMatchesSelector ||
                              Element.prototype.webkitMatchesSelector
  if (Element.prototype.matches) {
    return target.matches(targetSelector)
  } else {
    const matches = (target.document || target.ownerDocument).querySelectorAll(targetSelector)
    let i = matches.length - 1
    while (i >= 0 && matches.item(i) !== target) {
      i -= 1
    }
    return i > -1
  }
}
export function delegate(parent, targetSelector, events, foo) {
  // 触发执行的函数
  function triFunction(e) {
    // 兼容性处理
    const event = e || window.event

    // 获取到目标阶段指向的元素
    let target = event.target || event.srcElement

    // 获取到代理事件的函数
    const currentTarget = event.currentTarget

    // 遍历外层并且匹配
    while (target && target !== currentTarget) {
      // 判断是否匹配到我们所需要的元素上
      if (eleMatch(target, targetSelector)) {
        const sTarget = target
        foo(sTarget)
      }

      target = target.parentNode
    }
  }
  const parentDoms = parent instanceof window.HTMLElement ? [parent] : Array.prototype.slice.call(document.querySelectorAll(parent))
  // 如果有多个事件的话需要全部一一绑定事件
  events.split('.').forEach((evt) => {
    // 多个父层元素的话也需要一一绑定
    parentDoms.forEach(($p) => {
      $p.addEventListener(evt, triFunction)
    })
  })
}

export function createIframe(url, parent, onload) {
  onload = onload || function() {}
  parent = parent || document.body

  var iframe = document.createElement('IFRAME')
  iframe.scrolling = 'no'
  iframe.frameBorder = 0
  iframe.style.width = '0'
  iframe.style.height = '0'
  iframe.style.position = 'absolute'

  iframe.onload = onload.bind(iframe)
  iframe.src = url

  parent.appendChild(iframe)

  return iframe
}

function setTitle(title, vm) {
  if (typeof vm === 'object' && vm.params && vm.params.setTitle) {
    vm.params.setTitle(title)
  } else {
    document.title = title
    var iframe = document.createElement('iframe')
    iframe.style.visibility = 'hidden'
    iframe.style.display = 'none'
    iframe.style.width = '0'
    iframe.style.height = '0'
    iframe.style.border = 'none'
    iframe.src = '//static.udache.com/passenger/assets/images/pixel.png'
    iframe.onload = function () {
      setTimeout(function () {
        document.body.removeChild(iframe)
      }, 0)
    }
    document.body.appendChild(iframe)
  }
}

function dynamicSetFontSize() {
  let count = 5
  dynamicSet()
  let timer = setInterval(function () {
    if (!count) clearInterval(timer)
    dynamicSet()
    count--
  }, 200)
  window.removeEventListener('resize', dynamicSet)
  window.addEventListener('resize', dynamicSet)
}

function dynamicSet() {
  let width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || 0
  let fontSize = width * 20 / 375
  fontSize > 25 && (fontSize = 25)
  if (dynamicSet.cacheWidth === undefined || dynamicSet.cacheWidth !== width) {
    dynamicSet.cacheWidth = width
    document.documentElement.style.fontSize = fontSize + 'px'
  }
}

export default {
  dynamicSetFontSize,
  setTitle,
  createDom,
  children,
  removeDom,
  hasClass,
  addClass,
  removeClass,
  eleMatch,
  delegate,
  createIframe
}
